module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.7d5041aa.otf";